module.exports = __webpack_public_path__ + "img/SEFE_80X30.fe71ce60.png";